var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"itemAba",class:{'is-loading': _vm.loading}},[_c('produtividade',{staticClass:"wrapper m-t-xxl m-b",attrs:{"processo":_vm.processo.id,"full-component":"","disable-stats":""}},[_vm._v(" App indisponível no momento. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }